// frontend/src/config.js
export const API_URL = "https://wolfmind-v4-backend.onrender.com/api";
